import apiService from '../api';
import type { ApiService } from '../api';

export type CampaignLinkType = 'producerLinks' | 'affiliatesLinks' | 'myLinks';

interface ListCampaignsParams {
  productId: number;
  pagination: { current_page: number; per_page: number };
  type: CampaignLinkType;
  filters?: Record<string, unknown>;
}

class CampaignService {
  constructor(private apiService: ApiService) {}

  public listProductCampaigns(params: ListCampaignsParams): Promise<any> {
    const { productId, pagination, type, filters } = params;
    return this.apiService
      .get(`products/${productId}/campaigns`, {
        type,
        page: pagination.current_page,
        per_page: pagination.per_page,
        ...filters
      })
      .toPromise();
  }

  public createProductCampaign(productId: number, campaign: any): Promise<any> {
    return this.apiService.post(`products/${productId}/campaigns`, campaign).toPromise();
  }

  public editProductCampaign(productId: number, campaignId: number, data: any): Promise<any> {
    return this.apiService.put(`products/${productId}/campaigns/${campaignId}`, data).toPromise();
  }

  public listPostback(productId: number, destiny: string, type: string): Promise<any> {
    return this.apiService.get('trackers', { product_id: productId, destiny, type }).toPromise();
  }

  public updatePostback(productId: number, script: string, destiny: string, type: string): Promise<any> {
    return this.apiService.post('trackers', { product_id: productId, script, destiny, type }).toPromise();
  }

  public listProductsCampaignFilter(): Promise<any> {
    return this.apiService.get('products/campaigns-filter').toPromise();
  }
}

const campaignService = new CampaignService(apiService);
export default campaignService;
